import { UserOutlined } from "@ant-design/icons"
import { Dropdown, Menu, Button } from "antd"
import Cookies from "js-cookie"
import { useContext } from "react"
import GeneralContext from "../../context/GeneralContext/GeneralContext"
import styles from "../../services/styles"
import { displayMessage } from "../../services/helper"

const { tc1 } = styles

export default function ProfileOptions(props) {
  const {
    setLoggedUser,
    user, mobile_mode
  } = useContext(GeneralContext)

  const handleOnClickLogout = () => {
    setLoggedUser(false)
  }

  const items = [
    //   ...menus.topMenuItens.map(
    //     item => {
    //       return {
    //         key: item.key, label: (
    //           <Link style={{ color: tc1, fontSize: 16, marginTop: 12, }} to={item.key}>
    //             <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>

    //             </div>
    //           </Link>
    //         )
    //       }
    //     }
    //   ),
    { key: '/logout', label: <div onClick={handleOnClickLogout} style={{ color: tc1 }}>{displayMessage('LOGOUT')}</div> }
  ]

  const menu = items.map(item => (
    <Menu.Item key={item.key}>
      {item.label}
    </Menu.Item>
  ));

  return (
    <div style={{ color: "rgb(27, 54, 99)", fontSize: 17, fontWeight: "bold", lineHeight: mobile_mode ? 0 : 37, display: 'flex', alignItems: 'center', paddingRight: mobile_mode ? 15 : 0, marginRight: mobile_mode ? '' : 10 }}>
      <Dropdown
        overlay={<Menu>{menu}</Menu>}
        placement="bottomLeft"
        size="large"
      >
        <Button
          icon={<UserOutlined style={{ fontSize: 20, color: 'white' }} />}
          style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: mobile_mode ? 35 : 40, fontSize: 15, color: 'white', borderRadius: 5, minWidth: mobile_mode ? 40 : '' }}
        >
          {!mobile_mode && `${user?.first_name} ${user?.last_name}`}
        </Button>
      </Dropdown>
    </div>

  )
}

/*

 <>
      {/* <Dropdown
        className="dropdown-btn"
        menu={<Menu items={items} />}
        placement="bottomLeft"
        size="large"
      >
        <Button
          icon={<UserOutlined style={{ fontSize: 20, color: 'white' }} />}
          style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', fontSize: 15, color: 'rgb(27, 54, 99)' }}
        >
          <div style={{ fontSize: 17, fontWeight: "bold", color: 'white', marginLeft: 15, display: 'flex', alignItems: 'center', justifyContent: 'centerI' }}>
            {`${user?.first_name} ${user?.last_name}`}
          </div>
        </Button>
      </Dropdown> 
*/